import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleCreativeFilterModal } from '../../../../../slices/modals/reducer';

function Filters() {
  const dispatch = useDispatch();
  return (
    <button className='btn btn-ghost-primary' onClick={() => dispatch(toggleCreativeFilterModal())}>
      <i className='ri-equalizer-fill align-middle me-1'></i>
      Filters
    </button>
  )
}

export default Filters
